import React from 'react'

export function uneasiness() {
    return (
        <div>
            <div className='para'>
                I keep thinking that perhaps meditation will fix me, and then I think about something else that is not
                about fixing my core abstractions, and then I think about something that a finite automata modeled after
                those core abstractions would not recognize in its domain. And then I loop, working on ideas that no
                longer interest me, ideas that are not my own. I love randomness, and I’ve long held the view that it
                helps to have thinly connected nodes that you can pull up to reason. But I’ve grown weary, and I
                feel trapped.
            </div>
            <div className='para'>
                When I say core abstractions, I refer to those clusters of ideas that nearly every sensory input seems
                to appeal to. And not just appeal, these clusters are reinforced with every input that passes by, and
                how those inputs are fitted into the idea-cloud is also heavily directed by these clusters. If you try
                to explain your uneasiness in being by tracing a finger along the neural pathways from what you do, to
                the ideas that define you, you could easily see where the problem lies. And the only fix is to shorten
                that path.
            </div>
        </div>
    )
}
